import { createSelector } from '@reduxjs/toolkit';

export const selectExcelImportWizard = createSelector(
  ({ excelImportWizard }) => excelImportWizard,
  (state) => state,
);
